<template>
  <div class="menu-wrap">
    <div class="close-button">
      <svg @click="close"
           stroke="white" fill="white" stroke-width="0"
           viewBox="0 0 24 24"
           height="20px"
           width="20px"
           xmlns="http://www.w3.org/2000/svg"><path d="M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z" fill="white"></path></svg>
    </div>
    <div class="menu-content">
      <div class="section">
          {{ description }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DescriptionModal',
  emits: ['close'],
  props: {
    description: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};

</script>


<style lang="scss" scoped>

.vertical {
  .menu-content {
    display: flex;
    flex-direction: column;
    gap: 60px;
    line-height: 24px;
    padding: 70px 30px 30px 40px;
  }

}

.menu-wrap {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, .8);
  backdrop-filter: blur(1rem);
  z-index: 9;
  font-family: 'Inter', sans-serif;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  z-index: 10;
}

.share-button {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: white;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    color: #90bdff;
  }
}

.menu-content {
  border-radius: 4px;
  line-height: 24px;
  padding: 30px 60px 30px 40px;
  color: white;
  display: flex;
  gap: 120px;

  .share-header {
    text-transform: uppercase;
    font-size: 12px;
    color: #7e7d7d;
    margin-bottom: 20px;
    letter-spacing: 2px;
  }

  .share-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: white;
  }
}

.section {
  overflow: auto;
  max-height: 140px;
  height: 140px;
}

</style>
